<template>
  <div>
    <PageLoader v-bind:storage="appLoading" />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showSnackBar" color="#FF1313" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>

    <v-layout wrap justify-start pt-4 px-2 px-lg-0 pl-lg-4 pl-xl-4>
      <v-flex xs12>
        <v-layout pt-3 wrap justify-start>
          <v-flex xs12 text-left align-self-center>
            <span
              style="
                font-family: poppinssemibold;
                font-size: 22px;
                color: #1c1c1c;
              "
            >
              Inventory Report
            </span>
          </v-flex>
        </v-layout>
      </v-flex>

      <!-- Filters Section -->
      <v-flex xs12 pt-6>
        <v-card flat outlined class="pa-4 mr-lg-4">
          <v-layout wrap justify-start>
            <v-flex xs12 sm6 md3 lg3 xl3 px-2 pb-4>
              <span class="report-label">Main Category</span>
              <v-select
                outlined
                dense
                v-model="filters.mainCategory"
                :items="maincategoryArray"
                item-text="name"
                item-value="_id"
                placeholder="Select Main Category"
                hide-details
                @input="getCategory()"
                clearable
              ></v-select>
            </v-flex>

            <v-flex xs12 sm6 md3 lg3 xl3 px-2 pb-4>
              <span class="report-label">Category</span>
              <v-select
                outlined
                dense
                v-model="filters.category"
                :items="categoryArray"
                item-text="name"
                item-value="_id"
                placeholder="Select Category"
                hide-details
                @input="getSubcategory()"
                clearable
              ></v-select>
            </v-flex>

            <v-flex xs12 sm6 md3 lg3 xl3 px-2 pb-4>
              <span class="report-label">Subcategory</span>
              <v-select
                outlined
                dense
                v-model="filters.subcategory"
                :items="subcategoryArray"
                item-text="name"
                item-value="_id"
                placeholder="Select Subcategory"
                hide-details
                clearable
              ></v-select>
            </v-flex>

            <v-flex xs12 sm6 md3 lg3 xl3 px-2 pb-4>
              <span class="report-label">Status</span>
              <v-select
                outlined
                dense
                v-model="filters.status"
                :items="statusOptions"
                placeholder="Select Status"
                hide-details
              ></v-select>
            </v-flex>

            <v-flex xs12 px-2 pt-2>
              <v-layout wrap justify-space-between>
                <v-flex xs12 sm6 md4>
                  <v-btn
                    color="#3ea56e"
                    dark
                    depressed
                    class="text-capitalize"
                    @click="getReportData"
                  >
                    Generate Report
                  </v-btn>
                </v-flex>
                <v-flex xs12 sm6 md8 text-right v-if="inventoryData.length > 0">
                  <v-btn
                    outlined
                    color="red"
                    class="text-capitalize mr-2"
                    @click="downloadReport('pdf')"
                  >
                    <v-icon left small>mdi-file-pdf-box</v-icon>
                    Download PDF
                  </v-btn>
                  <v-btn
                    outlined
                    color="green"
                    class="text-capitalize"
                    @click="downloadReport('excel')"
                  >
                    <v-icon left small>mdi-file-excel</v-icon>
                    Download Excel
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>

      <!-- Summary Section -->
      <v-flex xs12 pt-6 v-if="summaryData && inventoryData.length > 0">
        <v-layout wrap justify-start>
          <v-flex xs12 sm6 md4 lg3 xl2 pa-2 v-for="(val, key) in summaryFields" :key="key">
            <v-card flat outlined class="pa-3 text-center" color="#f9f9f9">
              <div class="summary-label text-uppercase">{{ val }}</div>
              <div class="summary-value">{{ formatValue(key, summaryData[key]) }}</div>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>

      <!-- Report Table -->
      <v-flex xs12 pt-6 pr-lg-4>
        <v-card flat outlined>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left py-4">Product Name</th>
                  <th class="text-left">Main Category</th>
                  <th class="text-left">Category</th>
                  <th class="text-left">Subcategory</th>
                  <th class="text-center">Price</th>
                  <th class="text-center">Offer Price</th>
                  <th class="text-center">Quantity</th>
                  <th class="text-center">Status</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in inventoryData" :key="item._id">
                  <td class="text-left" style="font-family: poppinsmedium;">{{ item.productname }}</td>
                  <td class="text-left">{{ item.mainCategory ? item.mainCategory.name : '-' }}</td>
                  <td class="text-left">
                    <span v-for="(cat, index) in item.category" :key="cat._id">
                      {{ cat.name }}{{ index !== item.category.length - 1 ? ', ' : '' }}
                    </span>
                  </td>
                  <td class="text-left">
                    <span v-for="(sub, index) in item.subcategory" :key="sub._id">
                      {{ sub.name }}{{ index !== item.subcategory.length - 1 ? ', ' : '' }}
                    </span>
                  </td>
                  <td class="text-center">₹{{ item.price }}</td>
                  <td class="text-center">₹{{ item.offerPrice }}</td>
                  <td class="text-center" style="font-family: poppinssemibold;">{{ item.quantity }} {{ item.unit }}</td>
                  <td class="text-center">
                    <v-chip
                      small
                      :color="getStatusColor(item.status)"
                      dark
                    >
                      {{ item.status }}
                    </v-chip>
                  </td>
                </tr>
                <tr v-if="inventoryData.length === 0">
                  <td colspan="8" class="text-center py-8">
                    <span style="font-family: poppinsregular; color: #808080; font-size: 20px;">
                      Oops! No data found
                    </span>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      appLoading: false,
      ServerError: false,
      showSnackBar: false,
      timeout: 5000,
      msg: "",
      filters: {
        mainCategory: null,
        category: null,
        subcategory: null,
        status: "All",
      },
      statusOptions: ["All", "Pending", "Active", "Deleted", "Inactive", "Rejected"],
      categoryArray: [],
      subcategoryArray: [],
      inventoryData: [],
      summaryData: null,
      summaryFields: {
        totalProducts: "Total Products",
        totalStock: "Total Stock",
        outOfStockCount: "Out of Stock",
        totalValue: "Total Value",
      },
    };
  },
  computed: {
    maincategoryArray() {
      return this.$store.state.categories.data;
    },
  },
  beforeMount() {
    this.$store.dispatch("Category");
    this.getReportData();
  },
  methods: {
    getCategory() {
      if (!this.filters.mainCategory) {
        this.categoryArray = [];
        this.filters.category = null;
        this.filters.subcategory = null;
        return;
      }
      axios({
        method: "post",
        url: "/category/getlist",
        data: {
          mainCategoryId: this.filters.mainCategory,
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.categoryArray = response.data.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getSubcategory() {
      if (!this.filters.category) {
        this.subcategoryArray = [];
        this.filters.subcategory = null;
        return;
      }
      axios({
        method: "post",
        url: "/subcategory/getlist",
        data: {
          categoryId: this.filters.category,
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.subcategoryArray = response.data.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getReportData() {
      this.appLoading = true;
      const payload = { ...this.filters };
      // if (payload.status === "All") delete payload.status;

      axios({
        method: "POST",
        url: "/seller/report/inventory",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: payload,
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.inventoryData = response.data.inventoryData;
            this.summaryData = response.data.summary;
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
            this.inventoryData = [];
            this.summaryData = null;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    downloadReport(type) {
      const url = type === "pdf" ? "/seller/report/inventory/pdf" : "/seller/report/inventory/excel";
      const payload = { ...this.filters };
      // if (payload.status === "All") delete payload.status;

      this.appLoading = true;
      axios({
        method: "POST",
        url: url,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: payload,
        responseType: "blob",
      })
        .then((response) => {
          this.appLoading = false;
          const blob = new Blob([response.data], {
            type: type === "pdf" ? "application/pdf" : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = `SalesReport_${new Date().getTime()}.${type === "pdf" ? "pdf" : "xlsx"}`;
          link.click();
        })
        .catch((err) => {
          this.appLoading = false;
          this.msg = "Error downloading report";
          this.showSnackBar = true;
          console.log(err);
        });
    },
    formatDate(date) {
      if (!date) return "-";
      return new Date(date).toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });
    },
    formatLabel(key) {
      return this.summaryFields[key] || key;
    },
    formatValue(key, value) {
      if (key === "totalValue") {
        return "₹" + (value || 0).toFixed(2);
      }
      return value || 0;
    },
    getStatusColor(status) {
      switch (status) {
        case "Active":
          return "green";
        case "Pending":
          return "orange";
        case "Rejected":
          return "red";
        case "Deleted":
          return "grey";
        default:
          return "blue";
      }
    },
  },
};
</script>

<style scoped>
.report-label {
  font-family: poppinsmedium;
  font-size: 14px;
  color: #555;
  display: block;
  margin-bottom: 4px;
}
.summary-label {
  font-family: poppinsregular;
  font-size: 11px;
  color: #777;
}
.summary-value {
  font-family: poppinsbold;
  font-size: 18px;
  color: #3ea56e;
}
</style>
